import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate, getUserNameToName, formatDateToPtbr } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';

const CriticalPartsEmailList = (props) => {
    const messageModal = useRef();
    const [currentPage, setCurrentPage] = useState({ pageSize: 20, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [emails, setEmails] = useState([]);
    const [selectedId, setSelectedId] = useState(undefined);
    const [model, setModel] = useState({});

    useEffect(() => {
        props.getEmails();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setEmails([...props.emails || []]);
        // eslint-disable-next-line
    }, [props?.emails]);

    const openModal = (id) => {
        setSelectedId(id)
        messageModal.current.show();
    }

    const deleteSelectedItem = () => {
        props.deleteEmail(selectedId, () => {
            messageModal.current.close();
            props.getEmails();
        });
    };

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const add = () => {
        if (!validateInputsRequired()) {
            return;
        }

        props.addEmail({ email: model.email }, (data) => {
            model.createdBy = props.user.userName;
            model.createdOn = new Date();
            setModel({});
            props.getEmails();
            document.getElementById('email').focus();
        });
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'email',
                header: 'E-mail',
                align: 'left',
                sortable: false
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => openModal(row.id)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('config.critical-parts-registration.add-emails', 'container') }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="addSection"
                        header={translate('general:add')}
                        body={
                            <>
                                <form id="addForm" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="email"
                                                name='email'
                                                label={translate('general:email')}
                                                type="text"
                                                required
                                                value={model?.email || ''}
                                                onChange={onChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        add();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate("general:add")} onClick={() => add()} />
                                </div>
                            </>
                        }
                    />
                </div>
                <Table
                    totalPages={emails.length / currentPage.pageSize}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={emails}
                    actions={configActions()} />
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={deleteSelectedItem}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        emails: state.containerReducer.criticalPartsEmails
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addEmail: (model, callback) => {
            dispatch(ContainerService.insertCriticalPartEmail(model, callback));
        },
        getEmails: (vision) => {
            dispatch(ContainerService.getCriticalPartEmails(vision));
        },
        deleteEmail: (id, callback) => {
            dispatch(ContainerService.deleteCriticalPartEmail(id, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CriticalPartsEmailList));
